import React from "react";
import PopupMessage from "../PopupMessage";
import { useSelector } from "react-redux";
import { ContentPopup } from "./styles";

function Popup() {
  const { data } = useSelector((state) => state.popup);
  return (
    <ContentPopup>
      {data.map((popup, index) => (
        <PopupMessage {...popup} key={index} />
      ))}
    </ContentPopup>
  );
}

export default React.memo(Popup);
